<template>
  <!-- Container -->
  <div class="w-11/12 mx-auto mb-14">
    <h2 class="big-title mb-14">
      Menu
    </h2>
    <!-- Form container -->
    <div class="form-wrapper 2xl:w-9/12 mx-auto">
      <h3 class="form-title ">
        Create ingredient
      </h3>

      <!-- Form -->
      <form @submit.prevent="onSubmit" class="text-tableSubColor font-bold">
        <!-- Name -->
        <div class="w-full mb-4">
          <label
            >Name
            <input
              type="text"
              name="name"
              autocomplete="off"
              v-model="model.name"
              class="input"
              :class="{
                'is-invalid': v$.model.name.$error,
              }"
            />
            <span
              v-if="v$.model.name.$error"
              class="text-sm font-normal text-invalidColor"
              >{{ v$.model.name.$errors[0].$message }}</span
            >
          </label>
        </div>

        <div class="md:flex">
          <!-- Purchase Price -->
          <div class="w-full mb-4 md:mr-8">
            <label
              >Purchase Price
              <input
                type="number"
                name="price"
                autocomplete="off"
                v-model="model.price"
                class="input"
                :class="{
                  'is-invalid': v$.model.price.$error,
                }"
              />
              <span
                v-if="v$.model.price.$error"
                class="text-sm font-normal text-invalidColor"
                >{{ v$.model.price.$errors[0].$message }}</span
              >
            </label>
          </div>
          <!-- Selling Price -->
          <div class="w-full mb-4">
            <label
              >Selling Price
              <input
                type="number"
                name="selling_price"
                autocomplete="off"
                v-model="model.selling_price"
                class="input"
                :class="{
                  'is-invalid': v$.model.selling_price.$error,
                }"
              />
              <span
                v-if="v$.model.selling_price.$error"
                class="text-sm font-normal text-invalidColor"
                >{{ v$.model.selling_price.$errors[0].$message }}</span
              >
            </label>
          </div>
        </div>

        <!-- Description -->
        <div class="w-full mb-4">
          <label
            >Description
            <textarea
              rows="4"
              cols="30"
              name="description"
              autocomplete="off"
              v-model="model.description"
              class="input"
            ></textarea>
          </label>
        </div>

        <!-- Buttons -->
        <div class="w-full flex justify-end pt-4">
          <Button
            type="button"
            @click.prevent="back"
            btnTitle="Cancel"
            class="mr-4 bg-goldBeige text-black"
          />
          <Button type="submit" btnTitle="Save" class="bg-greenBtn" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Button from "../../../components/Button.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "IngredientsCreate",
  components: {
    Button,
  },
  data() {
    return {
      v$: useVuelidate(),
      model: {
        name: "",
        price: "",
        selling_price: "",
        description: "",
      },
    };
  },

  /* --- Validation --- */
  validations() {
    return {
      model: {
        name: { required },
        price: { required },
        selling_price: { required },
      },
    };
  },

  methods: {
    async onSubmit() {
      this.v$.$validate();
      if (!this.v$.$error) {
        try {
          await this.$store.dispatch("saveIngredient", this.model);
          //redirect
          this.$router.push("/ingredients");
        } catch (e) {
          alert(Object.values(e.response.data.messages).join(" "));
        }
      }
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>
